module.exports = __webpack_public_path__ + "static/media/pledgemine.d083e4f7.svg";